import { useTranslation } from "react-i18next";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import { Col, Modal, Row, Menu, Dropdown, Button } from "antd";
import { MoreHorizontal } from "react-feather";
import moment from "moment";

import { IPlanGeneral } from "@interfaces";
import { PATH_PLANS } from "@configs";
import { numberFormatter } from "@utils";

interface IProps {
    data: IPlanGeneral;
    handleDuplicate: (id: string) => void;
    handleDelete: (id: string) => void;
    index: number;
}

export const ComponentRowPlan = (props: IProps) => {
    //hooks
    const { t } = useTranslation();
    //props
    const { data, handleDelete, handleDuplicate } = props;

    const showModal = () => {
        Modal.confirm({
            title: t("message.delete_title"),
            icon: <ExclamationCircleOutlined />,
            content: t("message.delete_confirm", {
                returnObjects: true,
                name: t("object._segment"),
            }),
            okText: t("page.action.delete"),
            cancelText: t("page.action.cancel"),
            centered: true,
            onOk: () => handleDelete(data._id),
        });
    };

    const menu = (
        <Menu>
            <Menu.Item key={2}>
                <div className="delete-btn" onClick={() => handleDuplicate(data._id)}>
                    {t("page.action.duplicate")}
                </div>
            </Menu.Item>
            <Menu.Divider />
            <Menu.Item key={1}>
                <div className="duplicate-btn" onClick={showModal}>
                    {t("page.action.delete")}
                </div>
            </Menu.Item>
        </Menu>
    );

    return (
        <div className="table-row ">
            <Row style={{ height: "100%" }} gutter={24} type="flex" align="middle">
                <Col className="col-item" span={8}>
                    <Link to={`${PATH_PLANS}/${data._id}`}>
                        <p className="user-name">{data.name || "---"}</p>
                    </Link>
                </Col>
                <Col className="col-item" span={4}>
                    <p>{numberFormatter(data?.merchants)}</p>
                </Col>
                <Col className="col-item" span={4}>
                    <p>{moment(new Date(data?.createdAt || "")).format("DD/MM/YYYY")}</p>
                </Col>
                <Col className="col-item" span={4}>
                    <p>{data.status}</p>
                </Col>
                <Col span={4} className="field-more-btn">
                    <Dropdown
                        //@ts-ignore
                        getPopupContainer={(trigger) => trigger.parentNode}
                        overlay={menu}
                        trigger={["click"]}
                        placement="bottomRight"
                    >
                        <Button style={{ border: "unset" }}>
                            <MoreHorizontal />
                        </Button>
                    </Dropdown>
                </Col>
            </Row>
        </div>
    );
};
